/** Competitor compset / entity search: prefer instagram_graph only (skip plain instagram). */

export function isIncludedCompetitorSocialType(description) {
  const normalized = String(description ?? "").trim().toLowerCase()
  if (!normalized) return false
  if (normalized === "instagram") return false
  return true
}

export function mapCompetitorSocialAccount(account, index = 0) {
  const channel = account?.socialNetworkType?.description
  if (!isIncludedCompetitorSocialType(channel)) return null

  const url = String(account?.socialNetworkUrl ?? "").trim()
  if (!url) return null

  const accountId = Number(account?.id)
  const entityId = Number(account?.entityId)

  return {
    id: Number.isFinite(accountId) && accountId > 0 ? `sc-${accountId}` : `sc-${index}`,
    accountId: Number.isFinite(accountId) && accountId > 0 ? accountId : null,
    entityId: Number.isFinite(entityId) && entityId > 0 ? entityId : null,
    socialNetworkId: account?.socialNetworkId ?? null,
    channel,
    url,
    username: String(account?.socialNetworkUsername ?? "").trim(),
  }
}

export function mapCompetitorSocialAccounts(accounts) {
  if (!Array.isArray(accounts)) return []
  return accounts
    .map((account, index) => mapCompetitorSocialAccount(account, index))
    .filter(Boolean)
}
